/* eslint-disable no-restricted-imports */
import { EditablePersonInfo } from '@/data/Content/PersonInfo';
import { ButtonBase, Divider, Stack, Typography } from '@mui/material';
import { ACCOUNT_TABS } from '@/components/content/Account/parts/Tabs';
import {
	formatAddressByLines,
	isValidAddressByLines,
} from 'integration/utils/formatAddressByLines';
import {
	AccountSummaryPersonalDividerSX,
	AccountSummaryPersonalInfoLabelSX,
	AccountSummaryPersonalInfoValueSX,
} from '../styles/summaryPersonalInfo';
import { AccountSummaryLinkButtonSX } from '../styles/summary';

interface AccountSummaryPersonalInfoProps {
	personInfo: EditablePersonInfo;
	onSelectedTab: (tab: ACCOUNT_TABS) => void;
}

export const AccountSummaryPersonalInfo: React.FC<AccountSummaryPersonalInfoProps> = ({
	personInfo,
	onSelectedTab,
}) => {
	const handleGoToEdit = () => {
		onSelectedTab(ACCOUNT_TABS.PERSONAL_INFORMATION);
	};

	const address = isValidAddressByLines(personInfo?.addressLine1, personInfo?.addressLine2)
		? formatAddressByLines(personInfo?.addressLine1, personInfo.addressLine2)
		: 'Dirección no registrada';

	const cleanAddress = address
		.split(',')
		.map((item) => item.trim())
		.join(', ');
	return (
		<Stack spacing={{ xs: 4, md: 3 }}>
			<Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 2, md: 6 }}>
				<Stack>
					<Typography component={'h3'} sx={AccountSummaryPersonalInfoLabelSX}>
						{'Nombre'}
					</Typography>
					<Typography sx={AccountSummaryPersonalInfoValueSX}>
						{`${personInfo.firstName} ${personInfo.lastName}`}
					</Typography>
				</Stack>
				<Divider orientation="vertical" flexItem sx={AccountSummaryPersonalDividerSX} />
				<Stack>
					<Typography component={'h3'} sx={AccountSummaryPersonalInfoLabelSX}>
						{'Correo electrónico'}
					</Typography>
					<Typography sx={AccountSummaryPersonalInfoValueSX}>{personInfo.email1}</Typography>
				</Stack>
				<Divider orientation="vertical" flexItem sx={AccountSummaryPersonalDividerSX} />
				<Stack>
					<Typography component={'h3'} sx={AccountSummaryPersonalInfoLabelSX}>
						{'Dirección principal'}
					</Typography>
					<Typography sx={AccountSummaryPersonalInfoValueSX}>
						{cleanAddress === 'Dirección no registrada'
							? 'Dirección no registrada'
							: `${cleanAddress}, C.P. ${personInfo.zipCode ?? ''}, ${personInfo.city ?? ''}, ${
									personInfo.state ?? ''
							  }`}
					</Typography>
				</Stack>
			</Stack>
			<ButtonBase sx={AccountSummaryLinkButtonSX} onClick={handleGoToEdit}>
				{'Editar información personal'}
			</ButtonBase>
		</Stack>
	);
};
